module.exports = __webpack_public_path__ + "img/weihu.0b76b01c.png";